export default import.meta.ROLLDOWN_FILE_URL_CsFrCwLSzvD5LTOe6d9BNg